<template>
<span>
<slot>
<v-btn icon
  :small='small'
  :attrs='attrs'
  :disabled='!number'
  :class="classes"
  :href='whatsappIt(number, message)'
  target="_blank"
  @click.stop='noop' >
  <v-icon :small='small' color="success" >whatsapp</v-icon>
</v-btn>
</slot>
</span>
</template>
<script>
export default {
  name: 'WhatsAppBtn',
  props: {
    number: { type: String, required: true },
    message: { type: String, required: false, default: null },
    attrs: { type: Object },
    small: { type: Boolean, default: false },
    classes: { type: String, default: '' }
  },
  methods: {
    noop () { return null }
  }
}
</script>



// WEBPACK FOOTER //
// WhatsAppBtn.vue?6e0fec0e